( function ( $ ) {
	const indyPageHeader = $( '.wp-block-indy-page-header' );

	if ( indyPageHeader.length ) {
		window.addEventListener( 'scroll', function () {
			const scrollTop = window.scrollY + 200;
			const offset = indyPageHeader.offset().top;

			if ( offset < scrollTop ) {
				indyPageHeader.addClass( 'open-curtains' );
			} else {
				indyPageHeader.removeClass( 'open-curtains' );
			}
		} );
	}
} )( jQuery );
